<div class="container-fluid">
	<div class="row align-items-center mx-0">
		<div class="col">
			<h1 class="my-3 text-capitalize">Ecommerce</h1>
		</div>
		<div class="col-auto px-0 text-end">
			<button type="button" class="ml-2 btn btn-secondary" [routerLink]="['/add-ecommerce']">Agregar ecommercio</button>
		</div>
	</div>

	<div>
		<div class="row">
			<div class="col-6 col-md-3 form-group">
				<label class="">Nombre</label>
				<input type="text" name="name" [(ngModel)]="ecommerce_search.lk.name" class="form-control">
			</div>
			<div class="col-6 col-md-3">
				<label>&nbsp;</label>
				<div>
					<button type="button" class="w-100 btn btn-primary" (click)="search()">Buscar</button>
				</div>
			</div>
		</div>
	</div>

	<div  class="card p-3 mt-3">
		<app-loading [is_loading]="is_loading"></app-loading>
		<div class="table-responsive">
			<table class="table table-sm table-nowrap mb-0">
				<thead class="thead-light">
					<tr>
						<th>Nombre</th>
						<th>Capacidad</th>
						<th>Sucursal</th>
						<th>Requiere Limpieza</th>
						<th>Actualizacíon</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let ecommerce of ecommerce_list">
						<td>
							<a [routerLink]="['/edit-ecommerce',ecommerce.id]">{{ecommerce.name}}</a>
						</td>
						<td>{{ecommerce.updated | shortDate: 'relative' }}</td>
						<td>
							<a class="btn btn-primary" routerLink="/list-ecommerce-user" [queryParams]="{'eq.ecommerce_id':ecommerce.id}">Usuarios</a>
							<a class="btn btn-primary" routerLink="/list-ecommerce-item" [queryParams]="{'eq.ecommerce_id':ecommerce.id}">Artículos</a>
							<a class="btn btn-primary" [href]="rest.external_app_url + '/#/list-profile/' + ecommerce.id">Perfiles</a>
							<button type="button" class="btn btn-danger">x</button>
						</td>
					</tr>
					<tr *ngIf="ecommerce_list.length == 0 && !is_loading" colspan="TEMPLATE_HEADERS_SIZE">
						<div class="alert alert-light m-3" role="alert">No se encontraron elementos</div>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<app-pagination [path]="path" [pages]="pages" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
</div>
